import { CamelCaseKeys, NumericString } from '@utils/typescript';
import { InsuranceTypesEnum } from './InsuranceType';
import { InsurerLess } from './Insurer';
import { BenefitTemplateLess } from './BenefitTemplate';
import { UserLess } from './User';
import { PolicyTypes } from './policyType';
import { OrderStatuses } from './Order';
import { Company } from './Company';

export enum ActivationPeriods {
  OneWeek = 'one_week',
  OneMonth = 'one_month',
  ThreeMonths = 'three_months',
  SixMonths = 'six_months',
  OneYear = 'one_year'
}

export type InsurancePolicyList = CamelCaseKeys<{
  id: number;
  insurance_type: InsuranceTypesEnum;
  policy_type: PolicyTypes;
  policy_number?: string;
  status: OrderStatuses;
  total_premium: NumericString;
  total_premium_khr: NumericString;
}>;


export type InsurancePolicy = InsurancePolicyList & CamelCaseKeys<{
  insurer_id: number;
  benefit_template_id: number;
  frontline_user: UserLess;
  insurer: InsurerLess;
  company: Company;
  benefit_template: BenefitTemplateLess;
  admin_fee_amount: NumericString,
  admin_fee_final_amount: NumericString,
  premium: NumericString;
  final_premium: NumericString;
  activation_date: string;
  activation_period: ActivationPeriods;
  locked_at?: number;
  started_at: number;
  ended_at: number;
  note: string;
  proof: string;
  description_html: string;
}>;
